var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{
        'is-selected is-primary has-background-dark': _vm.editor.isActive(_vm.type),
    },on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fas",class:("fa-" + _vm.iconClass)})])])}
var staticRenderFns = []

export { render, staticRenderFns }